// tslint:disable: variable-name
import { BaseResourceModel } from '../../models/base-resource.model';
import { Compra } from '../compra/compra.model';
import { Orgao } from '../comum/orgao.model';
import { CardapioEtapaMerenda } from './cardapio-etapa-merenda.model';
import { CardapioItemMerenda } from './cardapio-item-merenda.model';

export class CardapioMerenda extends BaseResourceModel {
  constructor(
    public id?: number,
    public nome?: string,
    public descricao?: string,
    public compra?: Compra,
    public orgao?: Orgao,
    public itens?: CardapioItemMerenda[],
    public etapas?: CardapioEtapaMerenda[]) {
    super();
  }
  static converteJson(json: any): CardapioMerenda {
    return Object.assign(new CardapioMerenda(), json);
  }
}
